import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import '../Pagination.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { runMdMutation, isMdMutationLocked } from '../../services/mdMutationGuard';
import { MD_PAGE_SIZE, fetchAndApplyIndexPage } from '../../services/mdServerIndex';
import { ConfirmDialog } from '../common/ConfirmDialog';
import {
  buildStandardRowActions,
  MdRowActions,
  MdTableActionsCell,
  MdTableCell,
  MdTableHeaderCell,
} from '../common/MdRowActions';
import { PlusIcon, SearchIcon } from '../common/mdPageIcons';

function getPeriodoCursadaLabel(periodoCursadaDescripcion) {
  if (periodoCursadaDescripcion === '1') {
    return 'Primer Cuatrimestre';
  }
  if (periodoCursadaDescripcion === '2') {
    return 'Segundo Cuatrimestre';
  }
  return 'Anual';
}

export class MDPeriodoCursada extends Component {
  static displayName = MDPeriodoCursada.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      searchInput: '',
      perPage: MD_PAGE_SIZE,
      paginationData: [],
      totalCount: 0,
      pageCount: 0,
      offset: 0,
      currentPage: 0,
      showErrorMessage: false,
      errorMessage: '',
      successMessage: '',
      deletingId: null,
      pendingDelete: null,
    };
    this.searchInputRef = React.createRef();
  }

  componentDidMount() {
    if (constantClass.canAccess('WWPeriodoCursada')) {
      this.populateData();
    }
  }

  handleRemoveItem = (periodo) => {
    if (isMdMutationLocked(this)) return;
    this.setState({
      pendingDelete: {
        id: periodo.periodoCursadaCod,
        nombre: getPeriodoCursadaLabel(periodo.periodoCursadaDescripcion) + ' — ' + periodo.anioAcademicoDescripcion,
      },
    });
  };

  handleCancelDelete = () => {
    if (this.state.deletingId) return;
    this.setState({ pendingDelete: null });
  };

  handleConfirmDelete = () => {
    const { pendingDelete } = this.state;
    if (!pendingDelete || isMdMutationLocked(this)) return;
    this.deleteItem(pendingDelete.id);
  };

  handlePageClick = (e) => {
    this.populateData(e.selected, this.state.searchInput);
  };

  handleSearchInputChange = (e) => {
    const searchInput = e.target.value;
    const cleared = searchInput.trim() === '';
    this.setState({ searchInput, successMessage: '', showErrorMessage: false, errorMessage: '' });
    if (cleared && this.state.searchInput.trim() !== '') {
      this.populateData(0, '', { background: false });
    }
  };

  clearFeedback = () => {
    this.setState({ successMessage: '', showErrorMessage: false, errorMessage: '' });
  };

  handleSearchSubmit = (e) => {
    e.preventDefault();
    const search = (this.searchInputRef.current
      ? this.searchInputRef.current.value
      : this.state.searchInput).trim();
    this.setState({ searchInput: search });
    this.populateData(0, search, { background: false });
  };

  renderTable(periodos) {
    return (
      <div className="md-page__table-card">
        <table className="md-page__table md-page__table--actions-fixed" aria-labelledby="md-periodo-cursada-title">
          <thead>
            <tr>
              <MdTableHeaderCell cellType="text">Período</MdTableHeaderCell>
              <MdTableHeaderCell cellType="number">Año Académico</MdTableHeaderCell>
              <MdTableHeaderCell cellType="date">Fecha de Inicio</MdTableHeaderCell>
              <MdTableHeaderCell cellType="date">Fecha de Fin</MdTableHeaderCell>
              <MdTableHeaderCell cellType="date">Fecha de Inicio de Inscripción</MdTableHeaderCell>
              <MdTableHeaderCell cellType="date">Fecha de Fin de Inscripción</MdTableHeaderCell>
              <th scope="col" className="md-page__table__actions-header" aria-label="Acción" />
            </tr>
          </thead>
          <tbody>
            {periodos.map((periodo) => (
              <tr key={periodo.periodoCursadaCod}>
                <MdTableCell cellType="text">{getPeriodoCursadaLabel(periodo.periodoCursadaDescripcion)}</MdTableCell>
                <MdTableCell cellType="number">{periodo.anioAcademicoDescripcion}</MdTableCell>
                <MdTableCell cellType="date">{constantClass.formatDisplayDate(periodo.periodoCursadaFechaInicio)}</MdTableCell>
                <MdTableCell cellType="date">{constantClass.formatDisplayDate(periodo.periodoCursadaFechaFin)}</MdTableCell>
                <MdTableCell cellType="date">{constantClass.formatDisplayDate(periodo.periodoCursadaInicioInscripcio)}</MdTableCell>
                <MdTableCell cellType="date">{constantClass.formatDisplayDate(periodo.periodoCursadaFinInscripcion)}</MdTableCell>
                <MdTableActionsCell>
                  <MdRowActions
                    items={buildStandardRowActions({
                      editTo: '/update-pcr/' + periodo.periodoCursadaCod + '/0',
                      onDelete: () => this.handleRemoveItem(periodo),
                      deleteDisabled: this.state.loading || this.state.deletingId === periodo.periodoCursadaCod,
                      deleteLabel: this.state.deletingId === periodo.periodoCursadaCod ? 'Eliminando...' : 'Borrar',
                      detailTo: '/update-pcr/' + periodo.periodoCursadaCod + '/1',
                    })}
                  />
                </MdTableActionsCell>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const isBusy = this.state.loading || this.state.searching;
    const listLoading = this.state.loading && !this.state.deletingId;
    const { pendingDelete } = this.state;

    const contents = listLoading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderTable(this.state.paginationData);

    return (
      <div className="md-page md-periodo-cursada">
        <h1 id="md-periodo-cursada-title" className="md-page__title">Manejar Datos de Períodos de Cursadas</h1>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">
              {this.state.errorMessage}
            </div>
          ) : null}
          {this.state.successMessage ? (
            <div className="md-page__success">{this.state.successMessage}</div>
          ) : null}
        </div>

        <div className="md-page__toolbar">
          <Link className="md-page__action-link" to="/add-pcr">
            <PlusIcon />
            Nuevo Período de Cursada
          </Link>
        </div>

        <form className="md-page__search-row" onSubmit={this.handleSearchSubmit}>
          <div className="md-page__search-wrap">
            <span className="md-page__search-icon">
              <SearchIcon />
            </span>
            <input
              ref={this.searchInputRef}
              className="md-page__search-input"
              type="text"
              name="search"
              autoComplete="off"
              disabled={isBusy}
              placeholder="Ingrese Año Académico o Período"
              value={this.state.searchInput}
              onChange={this.handleSearchInputChange}
            />
          </div>
          <button type="submit" className="md-page__search-btn" disabled={isBusy}>
            Buscar
          </button>
        </form>

        {contents}

        {!listLoading && this.state.pageCount > 0 ? (
          <div className="md-page__pagination">
            <ReactPaginate
              previousLabel="Anterior"
              nextLabel="Siguiente"
              breakLabel="..."
              breakClassName="break-me"
              pageCount={this.state.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              forcePage={Math.floor(this.state.offset / this.state.perPage)}
              onPageChange={this.handlePageClick}
              containerClassName="pagination"
              subContainerClassName="pages pagination"
              activeClassName="active"
            />
          </div>
        ) : null}

        <ConfirmDialog
          open={Boolean(pendingDelete)}
          title="Eliminar período de cursada"
          message="Esta acción eliminará el período de cursada del sistema y no se puede deshacer."
          detail={pendingDelete ? pendingDelete.nombre : ''}
          confirmLabel="Eliminar"
          cancelLabel="Cancelar"
          variant="danger"
          loading={Boolean(this.state.deletingId)}
          onConfirm={this.handleConfirmDelete}
          onCancel={this.handleCancelDelete}
        />
      </div>
    );
  }

  async populateData(page = 0, search = '', options = {}) {
    await fetchAndApplyIndexPage(this, {
      indexUrl: 'api/pcr/Index',
      page,
      search: typeof search === 'string' ? search.trim() : '',
      perPage: this.state.perPage,
      background: options.background,
    });
  }

  async deleteItem(id) {
    this.clearFeedback();
    this.setState({ deletingId: id });
    await runMdMutation(this, async () => {
      const { data } = await constantClass.apiFetch('api/pcr/delete/' + id, {
        method: 'POST',
      });
      if (data === 'Timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      if (constantClass.isApiError(data) || data.returnModel === false) {
        this.setState({
          showErrorMessage: true,
          errorMessage: constantClass.getApiErrorMessage(
            data,
            'No se pudo eliminar el período de cursada. Verifique si tiene registros asociados e intente nuevamente.'
          ),
          pendingDelete: null,
        });
        return;
      }
      this.setState({ successMessage: 'El período de cursada se eliminó correctamente.', pendingDelete: null });
      await this.populateData(this.state.currentPage, this.state.searchInput);
    });
    this.setState({ deletingId: null });
  }
}
